import { Shark, Utils, View } from "shark-mvc";

import templateContent from "./document-list.html";

import agentFilterComponent from "../../_shark_components/agentFilter/agentFilterComponent";
import { breadcrumbComponent } from "../../_shark_jaws/components/breadcrumbComponent";
import { constructionSiteManager } from "../../_shark_jaws/managers/constructionSiteManager";
import constructionSiteCardEditView from "../constructionSite/constructionSiteCardEditView";
import { constructionSiteCardManager } from "../../_shark_jaws/managers/constructionSiteCardManager";
import displayColumnCountComponent from "../../components/displayColumnCount/displayColumnCountComponent";
import displaySortFieldComponent from "../../components/displaySortField/displaySortFieldComponent";
import { documentEditView } from "./documentEditView";
import { documentManager } from "../../_shark_jaws/managers/documentManager";
import { folderManagementComponent } from "../../_shark_jaws/components/folderManagementComponent";
import { folderManager } from "../../_shark_jaws/managers/folderManager";
import followUpComponent from "../../components/followUp/followUpComponent";
import { galleryEditView } from "./galleryEditView";
import { galleryManager } from "../../_shark_jaws/managers/galleryManager";
import liveSearchComponent from "../../_shark_components/liveSearch/liveSearchComponent";
import mainNavComponent from "../../_shark_jaws/components/mainNavComponent";
import { notComplianceReportEditView } from "../constructionSite/notComplianceReportEditView";
import { notComplianceReportManager } from "../../_shark_jaws/managers/notComplianceReportManager";
import { quotationManager } from "../../_shark_jaws/managers/quotationManager";
import refreshListButtonComponent from "../../components/refreshListButton/refreshListButtonComponent";
import showAllContactsButtonComponent from "../../components/showAllContactsButton/showAllContactsButtonComponent";
import siteInfoSheetDisplayView from "../site-info-sheets/siteInfoSheetDisplayView";
import { siteInfoSheetManager } from "../../_shark_jaws/managers/siteInfoSheetManager";
import siteInfoSheetOutdoorDisplayView from "../site-info-sheets/siteInfoSheetOutdoorDisplayView";
import { userManager } from "../../_shark_jaws/managers/userManager";
import visitEditView from "../visits/visitEditView";
import { visitManager } from "../../_shark_jaws/managers/visitManager";
import waitBoxComponent from "../../_shark_components/waitBox/waitBoxComponent";

class DocumentListView extends View {
	constructor () {
		super("documentListView");
		this.setTemplate(templateContent);
	}

	afterRender () {
		$(document).off("click", `[data-toggle="lightbox"]`, this.initLightBox);
		$(document).on("click", `[data-toggle="lightbox"]`, this.initLightBox);	
	}

	beforeLoad () {
		breadcrumbComponent.set("isActive", true);
		liveSearchComponent.behavior = "live";
	
		if (!Shark.get("userList") || Shark.get("userList").length === 0) {
			userManager.getList();
		}
	
		const requestedFolderBreadCrumb = Shark.get("requestedFolderBreadCrumb");
		let currFolder;
	
		if (requestedFolderBreadCrumb) {
			const folderBreadCrumb = Shark.get("documentsFolderBreadCrumb");
			currFolder = requestedFolderBreadCrumb[requestedFolderBreadCrumb.length - 1];
			currFolder.__active = true;
	
			Shark.set({
				currFolder,
				documentsFolderBreadCrumb: [
					{
						guid: "",
						name: "Documenti"
					},
					...requestedFolderBreadCrumb
				],
				requestedFolderBreadCrumb: null
			});
	
		}
		else {
			currFolder = Shark.get("currFolder");
		}
	
		if (currFolder) {
			this.getContentForFolder(currFolder);
		}
	}

	deleteDocumentBtn_clickHandler (event, data) {
		let selectedDocument = Utils.safp(Shark.get("documentList"), "guid", data.guid);

		if (selectedDocument && confirm("Sei sicuro di voler eliminare il documento?\nNon sarà possibile annullare l'operazione.")) {
			documentManager.delete2([selectedDocument])
			.then(response => {
				this.refreshList();
			});
		}
	}

	// getContentForFolder (folder) {
	// 	Shark.set({
	// 		folderConstructionSiteCardList: null,
	// 		folderNotComplianceReportList: null,
	// 		folderQuotationList: null,
	// 		folderSiteInfoSheetList: null,
	// 		folderVisitList: null,
	// 		systemDocumentList: null,
	// 	});

	// 	waitBoxComponent.show();

	// 	this.getFolderContent(folder);
	// 	this.getSystemContent(folder);
	// }
	getContentForFolder (folder) {
		Shark.set({
			folderConstructionSiteCardList: null,
			folderNotComplianceReportList: null,
			folderQuotationList: null,
			folderSiteInfoSheetList: null,
			folderVisitList: null,
			systemDocumentList: null,
		});
		console.log("APASDPASD DA QUIIIIII!")
		waitBoxComponent.show();
		
		Promise.all([
			this.getFolderContent(folder),
			this.getSystemContent(folder),
		]).then(() => {
			console.log("-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*");
			waitBoxComponent.hide();
			Shark.render();
		});
	}

	getFolderContent (currFolder) {
		return Promise.all([folderManager.getList(currFolder), documentManager.getList(currFolder), galleryManager.getList(currFolder)])
		.then(nousResponses => {
			console.log({nousResponses})
			console.log("E ALLORA RENDERIZZO TUTTO");
			// Shark.render();
			return true;
		});
	}

	// getFolderContent (currFolder) {
	// 	Promise.all([folderManager.getList(currFolder), documentManager.getList(currFolder), galleryManager.getList(currFolder)])
	// 	.then(nousResponses => {
	// 		console.log({nousResponses})
	// 		console.log("E ALLORA RENDERIZZO TUTTO");
	// 		waitBoxComponent.hide();
	// 		Shark.render();
	// 	});
	// }

	getSystemContent (currFolder) {
		console.log("getSystemContent", {currFolder});
		// Shark.set({
		// 	folderConstructionSiteCardList: null,
		// 	folderNotComplianceReportList: null,
		// 	folderQuotationList: null,
		// 	folderSiteInfoSheetList: null,
		// 	folderVisitList: null,
		// });

		if (currFolder.type === "client") {
			return visitManager.getByClientGuid(currFolder.referenceGuid)
			.then(response => {
				const folderVisitList = response.data;
				Shark.set({
					folderVisitList,
				});
				// Shark.render();
				return true;
			});
		}
		else if (currFolder.type === "siteInfoSheet") {
			//Dave.ToDo: Qui dovrei usare un promise.all
			return Promise.all([siteInfoSheetManager.getByGuidWithRevisions(currFolder.referenceGuid), visitManager.getBySiteInfoSheetGuid(currFolder.referenceGuid), documentManager.getSystemList(currFolder)])
			.then(nousResponses => {
				const folderSiteInfoSheetList = nousResponses[0].data;//Questa dovrebbe essere già una lista, perché dovrei prendere tutte le versioni di questa scheda
				// const folderVisitList = nousResponses[1].data;
				const systemDocumentList = nousResponses[2].data;

				Shark.set({
					folderNotComplianceReportList: [],
					folderQuotationList: [],
					folderSiteInfoSheetList,
					// folderVisitList,
					systemDocumentList,
					// __isClientFolder: true,
				});
				
				if (folderSiteInfoSheetList.length > 0) {
					let maxDate = null;
					let lastItem;
			
					folderSiteInfoSheetList.forEach(item => {
						if (item.createdAt > maxDate) {
							maxDate = item.createdAt;
							lastItem = item;
						}
					});
					
					if (lastItem) {
						lastItem.__isLastRevision = true;
					}
					
					const guidList = folderSiteInfoSheetList.map(item => item.guid);

					return quotationManager.getListBySiteInfoSheet(guidList)
					.then(nousResponseQuotation => {
						const folderQuotationList = nousResponseQuotation.data;

						if (folderQuotationList.length > 0) {
							maxDate = null;
							lastItem = null;
							
							folderQuotationList.forEach(item => {
								if (item.createdAt > maxDate) {
									maxDate = item.createdAt;
									lastItem = item;
								}
							});
							
							if (lastItem) {
								lastItem.__isLastRevision = true;

								lastItem.extraData.confirmData.pictures.forEach(item => {
									item.__thumbURL = item.thumbURL.substr(0, 6) === "images" ? item.thumbURL : Shark.get("__cdnURL") + "/" + item.thumbURL;
								});

								return constructionSiteCardManager.getByQuotation(lastItem)
								.then(constructionSiteCardListResponse => {
									console.log({constructionSiteCardListResponse});
									Shark.set({
										folderConstructionSiteCardList: constructionSiteCardListResponse.data
									});

									if (constructionSiteCardListResponse.data.length > 0) {
										const constructionSiteCard = constructionSiteCardListResponse.data[0];
										
										return constructionSiteManager.getByConstructionSiteCardGuid(constructionSiteCard.guid)
										.then(getByConstructionSiteCardResponse => {
											console.log({getByConstructionSiteCardResponse})

											if (getByConstructionSiteCardResponse.data.length > 0) {
												const constructionSite = getByConstructionSiteCardResponse.data[0];

												if (constructionSite.teamCloseDocumentGuid !== "") {
													const document = Utils.safp(constructionSite.attachments, "guid", constructionSite.teamCloseDocumentGuid);
													
													if (document && document.label && document.label !== "") {
														const fiscalClosingDocument = Shark.getInstance("Document", {
															fileSize: document.fileSize,
															fileType: document.type,
															fileURL: document.url,
															guid: document.guid,
															name: document.label,
															source: document.source,
															status: 1,
															thumbnailURL: document.thumbURL,
														});
														fiscalClosingDocument.set("role", "fiscalClosingDocument");

														const systemDocumentList = Shark.get("systemDocumentList");
														systemDocumentList.push(fiscalClosingDocument);
														// waitBoxComponent.hide();
														// Shark.render();
													}
												}
												// else {
												// 	//Dave: Questa roba è orribile.. dovrei restituire un oggetto con tutto e settarlo "di la" o cmq fare in un punto solo.
												// 	Shark.set({
												// 		folderQuotationList,
												// 		folderSiteInfoSheetList,
												// 		systemDocumentList,
												// 	});
												// 	return true;
												// }

												if (constructionSite.notComplianceReportCount > 0) {
													return notComplianceReportManager.getListByConstructionSite(constructionSite)
													.then(getListByConstructionSiteResponse => {
														console.log({getListByConstructionSiteResponse})

														if (getListByConstructionSiteResponse.data.length > 0) {
															Shark.set({
																folderNotComplianceReportList: getListByConstructionSiteResponse.data
															});
														}
														return true;
													});
												}
												else {
													//Dave: Questa roba è orribile.. dovrei restituire un oggetto con tutto e settarlo "di la" o cmq fare in un punto solo.
													Shark.set({
														folderQuotationList,
														folderSiteInfoSheetList,
														systemDocumentList,
													});
													return true;
												}
											}
											else {
												//Dave: Questa roba è orribile.. dovrei restituire un oggetto con tutto e settarlo "di la" o cmq fare in un punto solo.
												Shark.set({
													folderQuotationList,
													folderSiteInfoSheetList,
													systemDocumentList,
												});
												return true;
											}
										});
									}
									else {
										//Dave: Questa roba è orribile.. dovrei restituire un oggetto con tutto e settarlo "di la" o cmq fare in un punto solo.
										Shark.set({
											folderQuotationList,
											folderSiteInfoSheetList,
											systemDocumentList,
										});
										return true;
									}
								});
							}
						}

						Shark.set({
							folderQuotationList,
							folderSiteInfoSheetList,
							systemDocumentList,
						});
						return true;
						Shark.set({
							folderQuotationList
						});
						console.log("QUI 1", Shark.get([
							"folderQuotationList",
							"folderSiteInfoSheetList",
							"folderVisitList",
							"__isClientFolder",
						]));
						waitBoxComponent.hide();
						Shark.render();
					});
				}
				else {
					console.log("QUI 2", {folderSiteInfoSheetList});
					waitBoxComponent.hide();
					return true;
					Shark.render();
				}

				// console.log("************************************************************************");
				// console.log("************************************************************************");
				// console.log({nousResponses}); // [3, 1337, "foo"] 
				// console.log("************************************************************************");
				// console.log("************************************************************************");
			});
		}
		else if (["constructionSite", "notComplianceReport"].indexOf(currFolder.type) > -1) {
			return documentManager.getSystemList(currFolder)
			.then(getSystemListResponse => {
				const systemDocumentList = getSystemListResponse.data;

				Shark.set({
					folderConstructionSiteCardList: [],
					systemDocumentList,
				});
				return true;
			})
		}
	}

	init () {
		this.addComponents([agentFilterComponent, breadcrumbComponent, displayColumnCountComponent, displaySortFieldComponent, folderManagementComponent, liveSearchComponent, mainNavComponent, refreshListButtonComponent, showAllContactsButtonComponent, waitBoxComponent]);
	
		Shark.set({
			agentList: Shark.get("agentList") || [],
			documentList: Shark.get("documentList") || [],
			folderList: Shark.get("folderList") || [],
			folderConstructionSiteCardList: [],
			folderNotComplianceReportList: [],
			galleryList: Shark.get("galleryList") || [],
			currDocumentFolder: { guid: "" },
			currFolder: Shark.getInstance("Folder"),
			documentsFolderBreadCrumb: [
				{
					guid: "",
					name: "Documenti"
				}
			],
			systemDocumentList: Shark.get("systemDocumentList") || [],
		});
	
		this.set({
			__htmlTitle: "Documenti e Immagini | IPM HUB"
		});
	}

	initLightBox (event) {
		event.preventDefault();
		event.stopPropagation();

		$(event.currentTarget).ekkoLightbox({
			alwaysShowClose: true
		});
	}

	refreshList () {
		const currFolder = Shark.get("currFolder");

		if (currFolder) {
			this.getContentForFolder(currFolder);
		}
	}





	
	beforeRender () {
		const subFolders = [];
		const folderBreadCrumb = Shark.get("documentsFolderBreadCrumb");
		// console.log({folderBreadCrumb});

		let currFolder = Shark.get("currFolder");
		const isClientFolder = (currFolder.clientGuid && currFolder.clientGuid !== "") || currFolder.type === "client";

		//Dave: Questo va impostato al ricevimento dei dati, non prima del render... 
		//devo cercare di spostare tutta la roba che ora esiste al before render... follia, lo so
		const [agentFilter, folderList] = Shark.get(["agentFilter", "folderList"]);
		folderList.forEach(item => {
			item.__render = agentFilter.agentGuid === "" || item.ownerGuid === "" || item.ownerGuid === agentFilter.agentGuid;
		});
		displaySortFieldComponent.sortFolderList(folderList);

		this.set({
			__isClientFolder: isClientFolder,
			__showSystemDocuments: ["siteInfoSheet"].indexOf(currFolder.type) > -1,

			__showDocuments: Shark.get("documentList").length > 0 || Shark.get("__isClientFolder"),
			__showGalleries: Shark.get("galleryList").length > 0,
			__showOnwerActionBtns: currFolder.ownerGuid === Shark.get("currUser").guid || Shark.get("currUser").hasPermission("manageDocuments"),
		});
	}

	breadCrubmBtn_clickHandler (event, data) {
		event.preventDefault();
		
		const folderList = Shark.get("documentsFolderBreadCrumb");
		
		for (let i = folderList.length - 1; i >= 0; i--) {
			if (folderList[i].guid !== data.guid) {
				folderList.pop();
			}
			else {
				break;
			}
		}
		const currFolder = folderList[folderList.length - 1];

		if (currFolder) {
			currFolder.__active = true;
			liveSearchComponent.reset();
			this.getContentForFolder(currFolder);
			// documentListView.getSystemContent(currFolder);
			// documentListView.getFolderContent(currFolder);
		}
	}

	createFolderBtn_clickHandler () {
		const itemClassList = document.querySelector("#newFolderTray").classList;

		if (itemClassList.contains("show")) {
			itemClassList.remove("show");
			Shark.set("editingFolder", null);
		}
		else {
			document.querySelector("#newFolderNameField").value = "";
			itemClassList.add("show");
			document.querySelector("#newFolderNameField").focus();
		}
	}

	createGalleryBtn_clickHandler () {
		Shark.set({
			currGallery: Shark.getInstance("Gallery", {
				createdByGuid: Shark.get("currUser").guid,
				folderGuid: Shark.get("currFolder").guid,
				status: 1,
				tags: []
			}),
			pictureList: [],
			isEditing: true,
		});
		Shark.openPage(galleryEditView);
	}

	createNewDocumentBtn_clickHandler () {
		Shark.set({
			editingDocument: Shark.getInstance("Document", {
				createdByGuid: Shark.get("currUser").guid,
				folderGuid: Shark.get("currFolder").guid,
				status: 1,
				tags: []
			}),
			isEditing: true
		});
		Shark.openPage(documentEditView);
	}

	folderManager_savedHandler () {
		document.querySelector("#newFolderTray").classList.remove("show");
	}

	saveNewFolderBtn_clickHandler () {
		const field = document.querySelector("#newFolderNameField");
		
		if (field && field.value !== "") {
			const currFolder = Shark.get("currFolder");
			const editingFolder = Shark.get("editingFolder");

			if (editingFolder) {
				editingFolder.name = field.value;
				folderManager.save(editingFolder);
			}
			else {
				const newFolder = Shark.getInstance("Folder", {
					name: field.value,
					ownerGuid: currFolder.ownerGuid !== "" ? Shark.get("currUser").guid : "",
					parentGuid: currFolder.guid,
					status: 1,
					type: "documents"
				});
				folderManager.save(newFolder);
			}
		}
	}

	singleConstructionSiteCard_clickHandler (event, data) {
		const currConstructionSiteCard = Utils.safp(Shark.get("folderConstructionSiteCardList"), "guid", data.guid);

		if (currConstructionSiteCard) {
			followUpComponent.set("targetItem", currConstructionSiteCard);

			Shark.set({
				currConstructionSiteCard,
				isEditingConstructionSiteCard: false,
			});
		
			// if (currConstructionSiteCard.type === "industrial") {
				Shark.openPage(constructionSiteCardEditView);
			// }
		}
	}

	singleDocument_clickHandler (event, data) {
		if (event.target.closest(".notClickable") !== null) {//Dave: questa cosa va migliorata, anche se così è meglio del classlist.contains
			return;
		}
		if (event.target.classList.contains("notClickable")) {
			return;
		}

		let selectedDocument = Utils.safp(Shark.get("documentList"), "guid", data.guid);

		if (Shark.get("currFolder").ownerGuid === "" && Shark.get("currUser").hasPermission("manageDocuments")) {
			Shark.set({
				editingDocument: selectedDocument,
				isEditing: false
			});
			Shark.openPage(documentEditView);
		}
		else if (selectedDocument && selectedDocument.fileURL !== "") {
			window.open(Shark.get("__cdnURL") + "/" + selectedDocument.fileURL);
		}
	}

	singleNotComplianceReportCard_clickHandler (event, data) {
		const currNotComplianceReport = Utils.safp(Shark.get("folderNotComplianceReportList"), "guid", data.guid);

		if (currNotComplianceReport) {
			followUpComponent.set("targetItem", currNotComplianceReport);

			Shark.set({
				currNotComplianceReport,
			});

			notComplianceReportEditView.set({isEditing: false});
			Shark.openPage(notComplianceReportEditView);
		}
	}

	singleSystemDocument_clickHandler (event, data) {
		if (event.target.classList.contains("notClickable")) {
			return;
		}

		let selectedDocument = Utils.safp(Shark.get("systemDocumentList"), "guid", data.guid);

		if (selectedDocument && selectedDocument.fileURL !== "") {
			window.open(Shark.get("__cdnURL") + "/" + selectedDocument.fileURL);
		}
	}

	singleSiteInfoSheet_clickHandler (event, data) {
		const currSiteInfoSheet = Utils.safp(Shark.get("folderSiteInfoSheetList"), "guid", data.guid);

		if (currSiteInfoSheet) {
			followUpComponent.set("targetItem", currSiteInfoSheet);

			Shark.set({
				currSiteInfoSheet,
				isEditingSiteInfoSheet: false,
			});
		
			if (currSiteInfoSheet.type === "industrial") {
				Shark.openPage(siteInfoSheetDisplayView);
			}
			else {
				Shark.openPage(siteInfoSheetOutdoorDisplayView);
			}
		}
	}

	singleQuotation_clickHandler (event, data) {
		if (event.target.classList.contains("confirmThumb")) {
			return;
		}
		
		const currQuotation = Utils.safp(Shark.get("folderQuotationList"), "guid", data.guid);

		if (currQuotation) {
			Shark.set({currQuotation});
			window.open(`${Shark.get("__cdnURL")}/${currQuotation.pdfURL}`, "_blank");
		}
	}

	singleVisit_clickHandler (event, data) {
		const currVisit = Utils.safp(Shark.get("folderVisitList"), "guid", data.guid);

		if (currVisit) {
			followUpComponent.set("targetItem", currVisit);
			Shark.set({
				currVisit,
				__isEditingVisit: false,
			});
			Shark.openPage(visitEditView);
		}
	}

	singleGalleryBox_clickHandler (event, data) {
		let currGallery = Utils.safp(Shark.get("galleryList"), "guid", data.guid);
		Shark.set("currGallery", currGallery);
		Shark.set("isEditing", false);
		Shark.openPage(galleryEditView);
	}

	subFolderBtn_clickHandler (event, data) {
		let currFolder = Utils.safp(Shark.get("folderList"), "guid", data.guid);

		if (currFolder) {
			const folderBreadCrumb = Shark.get("documentsFolderBreadCrumb");
			folderBreadCrumb[folderBreadCrumb.length - 1].__active = false;
			currFolder.__active = true;

			liveSearchComponent.reset();
			this.getContentForFolder(currFolder);
			// documentListView.getSystemContent(currFolder);
			folderBreadCrumb.push(currFolder);
			// documentListView.getFolderContent(currFolder);
		}
	}
}

const documentListView = new DocumentListView("documentListView");

Shark.registerView(documentListView);

export { documentListView };
